"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataCenterIds = exports.DC_SPECIFIC_SUBDOMAINS = void 0;
exports.getDataCenterById = getDataCenterById;
exports.getDataCenterIdFromCurrentUrl = getDataCenterIdFromCurrentUrl;
exports.getDefaultSubdomainForDataCenter = getDefaultSubdomainForDataCenter;
var _parseDomain = require("parse-domain");
var _dataCenters = _interopRequireDefault(require("./data/dataCenters.json"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var DataCenterIds;
(function (DataCenterIds) {
  DataCenterIds["US"] = "0";
  DataCenterIds["CA"] = "1";
  DataCenterIds["EU"] = "2";
})(DataCenterIds || (exports.DataCenterIds = DataCenterIds = {}));
var DC_SPECIFIC_SUBDOMAINS;
/**
 * Returns the data center by id
 * @param {string} dataCenterId
 * @returns {Object} data center details
 * @memberof module:@sm/locale
 */
(function (DC_SPECIFIC_SUBDOMAINS) {
  DC_SPECIFIC_SUBDOMAINS[DC_SPECIFIC_SUBDOMAINS["eu"] = DataCenterIds.EU] = "eu";
})(DC_SPECIFIC_SUBDOMAINS || (exports.DC_SPECIFIC_SUBDOMAINS = DC_SPECIFIC_SUBDOMAINS = {}));
function getDataCenterById(dataCenterId) {
  return _dataCenters.default.dataCenters[dataCenterId];
}

/**
 * Returns the data center id from the url
 * @param {string} url
 * @param {string} dataCenterAffinityCookie
 * @returns {string} data center id
 * @memberof module:@sm/locale
 */
function getDataCenterIdFromCurrentUrl(url, dataCenterAffinityCookie) {
  var parseResult = (0, _parseDomain.parseDomain)((0, _parseDomain.fromUrl)(url)) || {};
  var subdomain;
  var dataCenterId = DataCenterIds.US;
  if (parseResult.type === _parseDomain.ParseResultType.Listed) {
    subdomain = parseResult.subDomains.join('.');
    if (subdomain) {
      var dcSub = Object.keys(_dataCenters.default.dataCenterSpecificSubdomains).find(function (subSpecific) {
        return subSpecific === subdomain || subdomain.endsWith(".".concat(subSpecific));
      });
      if (dcSub) {
        dataCenterId = _dataCenters.default.dataCenterSpecificSubdomains[dcSub];
      }
    }
  }
  if (dataCenterId === DataCenterIds.US && "".concat(dataCenterAffinityCookie) === DataCenterIds.CA) {
    dataCenterId = DataCenterIds.CA;
  }
  return dataCenterId;
}

// This is currently being used in UserWeb here https://code.corp.surveymonkey.com/devmonkeys/userweb/blob/e7646369dfae9fef0c8d1fa3c23f1bde61a9c906/userweb/lib/language.py#L31
// So I'm leaving this function for when we port the corresponding code in UserWeb.
/**
 * Returns the default subdomain for a data center
 * @param {string} dataCenterId
 * @returns {string} subdomain
 * @memberof module:@sm/locale
 */
function getDefaultSubdomainForDataCenter(dataCenterId) {
  var dc = getDataCenterById(dataCenterId);
  return dc && dc.defaultSubdomain || 'www';
}